// Action types
export const CHANGE_ONBOARDING = 'change_onboarding'

export const changeOnboarding = onboarding => {
  return {
    type: CHANGE_ONBOARDING,
    payload: onboarding,
  }
}
